import type { FC } from 'react'
import styled from 'styled-components'

interface ListProps {
  header: React.ReactNode
  listItemIconPath: string
  items: string[]
}

const Container = styled.div`
  display: grid;
  grid-template-rows: min-content 1fr;
  grid-row-gap: 20px;
  justify-items: stretch;

  & ul {
    margin: 0;
    padding: 0;
  }
`

const Header = styled.h3`
  margin: 0;
  justify-self: center;
`

const NoDataContainer = styled.div`
  text-align: center;
`

const ListItem = styled.div`
  display: grid;
  grid-template-columns: min-content 1fr;
  grid-column-gap: 5px;
  margin-bottom: 10px;
  align-items: baseline;

  img {
    width: 12px;
    height: 12px;
  }
`

const List: FC<ListProps> = ({ header, listItemIconPath, items }) => (
  <Container>
    <Header>{header}</Header>
    <div>
      {items.length > 0 ? (
        <ul>
          {items.map((reason: string, i) => {
            return (
              <ListItem key={i}>
                <img src={listItemIconPath} alt="" />
                {reason}
              </ListItem>
            )
          })}
        </ul>
      ) : (
        <NoDataContainer>Nothing to show here!</NoDataContainer>
      )}
    </div>
  </Container>
)

export default List
